import React, {useEffect, useState} from "react";
import {Form, Tooltip} from "antd";
import Seperator from "./Seperator";
import CheckboxGroupWithJointCheckAll from "./CheckboxGroupWithJointCheckAll";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";
import useInputs from "../../../utils/hooks/useInputs";
import "./WidgetSearchByUid.scss";

//export const OPTIONS = [
// 단순히 화면에 보이는 위젯 순서를 위해 사용. 사용안할경우 Todo.option으로 활성화

const OPTIONS_CLS = [
  {cls_code: "32", label: "기지국(32)"},
  {cls_code: "42", label: "의무선박국(42)"},
  {cls_code: "21", label: "고정국(21)"},
  {cls_code: "80", label: "일반지구국(80)"},
  {cls_code: "72", label: "지구국(72)"},
  {cls_code: "44", label: "육상무선국(44)"},
  {cls_code: "41", label: "선박국(41)"},
  {cls_code: "73", label: "선박지구국(73)"},
  {cls_code: "76", label: "육상이동지구국(76)"},
  {cls_code: "46", label: "의무항공기국(46)"},
  {cls_code: "93", label: "실용화시험국(실험국용)(93)"},
  {cls_code: "91", label: "실험국(91)"},
  {cls_code: "71", label: "우주국(71)"},
  {cls_code: "52", label: "무선표지국(52)"},
  {cls_code: "75", label: "이동지구국(75)"},
  {cls_code: "57", label: "무선탐지육상국(57)"},
  {cls_code: "61", label: "비상국(61)"},
  {cls_code: "92", label: "아마추어국(92)"},
  {cls_code: "74", label: "해안지구국(74)"},
  {cls_code: "55", label: "무선측위국(55)"},
  {cls_code: "45", label: "항공기국(45)"},
  {cls_code: "78", label: "항공기지구국(78)"},
  {cls_code: "70", label: "육상지구국(70)"},
  {cls_code: "49", label: "이동국(49)"},
  {cls_code: "53", label: "무선항행육상국(53)"},
  {cls_code: "54", label: "무선항행이동국(54)"},
  {cls_code: "81", label: "산업용(81)"},
  {cls_code: "99", label: "전파천문국(99)"},
];

/*
const OPTIONS_CLS = [
  {cls_code: "32", label: "기지국"},
  {cls_code: "42", label: "의무선박국"},
  {cls_code: "21", label: "고정국"},
  {cls_code: "80", label: "일반지구국"},
  {cls_code: "72", label: "지구국"},
  {cls_code: "44", label: "육상무선국"},
  {cls_code: "41", label: "선박국"},
  {cls_code: "73", label: "선박지구국"},
  {cls_code: "76", label: "육상이동지구국"},
  {cls_code: "46", label: "의무항공기국"},
  {cls_code: "93", label: "실용화시험국(실험국용)"},
  {cls_code: "91", label: "실험국"},
  {cls_code: "71", label: "우주국"},
  {cls_code: "52", label: "무선표지국"},
  {cls_code: "75", label: "이동지구국"},
  {cls_code: "57", label: "무선탐지육상국"},
  {cls_code: "61", label: "비상국"},
  {cls_code: "92", label: "아마추어국"},
  {cls_code: "74", label: "해안지구국"},
  {cls_code: "55", label: "무선측위국"},
  {cls_code: "45", label: "항공기국"},
  {cls_code: "78", label: "항공기지구국"},
  {cls_code: "70", label: "육상지구국"},
  {cls_code: "49", label: "이동국"},
  {cls_code: "53", label: "무선항행육상국"},
  {cls_code: "54", label: "무선항행이동국"},
  {cls_code: "81", label: "산업용"},
  {cls_code: "99", label: "전파천문국"},
];
*/

/*
const OPTIONS_CLS = [
    {cls_code: "32", label: "기지국"},
    {cls_code: "85", label: "이동중계국"},
    {cls_code: "94", label: "간이무선국"},
    {cls_code: "44", label: "육상이동국"},
    {cls_code: "49", label: "이동국"},
    {cls_code: "92", label: "아마추어국"},
    {cls_code: "42", label: "의무선박국"},
    {cls_code: "41", label: "선박국"},
    {cls_code: "21", label: "고정국"},
    {cls_code: "35", label: "육상국"},
    {cls_code: "11", label: "지상파방송국"},
    {cls_code: "12", label: "실용화시험국(방송국용)"},
    {cls_code: "13", label: "위성방송국"},
    {cls_code: "15", label: "신고제외무선국"},
    {cls_code: "16", label: "지상파방송보조국"},
    {cls_code: "17", label: "발신전용휴대전화(CT-2)"},
    {cls_code: "18", label: "가입자회선용무선국"},
    {cls_code: "19", label: "위성방송보조국"},
    {cls_code: "22", label: "전송망"},
    {cls_code: "23", label: "종합유선방송국"},
    {cls_code: "24", label: "중계유선방송"},
    {cls_code: "25", label: "음악유선방송"},
    {cls_code: "27", label: "개인휴대전화(PCS)"},
    {cls_code: "28", label: "주파수공용무선전화(자가용)"},
    {cls_code: "29", label: "무선조정중계국"},
    {cls_code: "30", label: "무선조정이동국"},
    {cls_code: "31", label: "해안국"},
    {cls_code: "33", label: "항공국"},
    {cls_code: "34", label: "휴대기지국"},
    {cls_code: "36", label: "일반해안국"},
    {cls_code: "37", label: "무선데이타통신"},
    {cls_code: "38", label: "어업용해안국"},
    {cls_code: "40", label: "구명부기국"},
    {cls_code: "43", label: "비상위치지시용무선표지국"},
    {cls_code: "45", label: "항공기국"},
    {cls_code: "46", label: "의무항공기국"},
    {cls_code: "47", label: "휴대국"},
    {cls_code: "48", label: "선상통신국"},
    {cls_code: "50", label: "선박국대여"},
    {cls_code: "51", label: "무선방향탐지국"},
    {cls_code: "52", label: "무선표지국"},
    {cls_code: "53", label: "무선항행육상국"},
    {cls_code: "54", label: "무선항행이동국"},
    {cls_code: "55", label: "무선측위국"},
    {cls_code: "56", label: "무선항행국"},
    {cls_code: "57", label: "무선탐지육상국"},
    {cls_code: "58", label: "무선탐지이동국"},
    {cls_code: "59", label: "비상위치지시용위성무선표지국"},
    {cls_code: "61", label: "비상국"},
    {cls_code: "62", label: "표준주파수및시보국"},
    {cls_code: "63", label: "기상원조국"},
    {cls_code: "64", label: "구내무선국"},
    {cls_code: "65", label: "주파수공용간이무선국"},
    {cls_code: "66", label: "차량디지틀이동전화"},
    {cls_code: "67", label: "휴대디지틀이동전화"},
    {cls_code: "68", label: "차량/휴대디지틀이동전화"},
    {cls_code: "69", label: "위성휴대통신용무선국"},
    {cls_code: "70", label: "육상지구국"},
    {cls_code: "71", label: "우주국"},
    {cls_code: "72", label: "지구국"},
    {cls_code: "73", label: "선박지구국"},
    {cls_code: "74", label: "해안지구국"},
    {cls_code: "75", label: "이동지구국"},
    {cls_code: "76", label: "육상이동지구국"},
    {cls_code: "77", label: "항공지구국"},
    {cls_code: "78", label: "항공기지구국"},
    {cls_code: "79", label: "기지지구국"},
    {cls_code: "80", label: "일반지구국"},
    {cls_code: "81", label: "산업용"},
    {cls_code: "82", label: "통신용"},
    {cls_code: "83", label: "의료용"},
    {cls_code: "84", label: "차량이동가입무선전화"},
    {cls_code: "86", label: "휴대이동가입무선전화"},
    {cls_code: "87", label: "주파수공용무선전화"},
    {cls_code: "88", label: "생활무선국(CB)"},
    {cls_code: "89", label: "차량/휴대가입무선전화"},
    {cls_code: "90", label: "이동품질감시"},
    {cls_code: "91", label: "실험국"},
    {cls_code: "93", label: "실용화시험국(실험국용)"},
    {cls_code: "95", label: "고정수신국"},
    {cls_code: "96", label: "무선호출국"},
    {cls_code: "97", label: "무선조정국"},
    {cls_code: "98", label: "코드레스폰"},
    {cls_code: "99", label: "전파천문국"},
    // {cls_code: "RD", label: "레이다펄스변조송신"},
    // {cls_code: "TV", label: "TV방송국"},
];
*/

// eslint-disable-next-line no-unused-vars
const OPTIONS_FRQ = [
  {frq: '1', label: "주파수"},
];

// 무선국구분코드
const OPTIONS_DIV = [
  {div_code: "00",  label: "전체"},
  {div_code: "01",  label: "일반무선국"},
  {div_code: "02",  label: "간이무선국"},
  {div_code: "04",  label: "방송국"},
  {div_code: "05",  label: "유선방송국"},
  {div_code: "06",  label: "전파응용설비"},
  {div_code: "07",  label: "신고무선국"},
  {div_code: "08",  label: "전송망"},
];

// 무선국상태코드
const OPTIONS_STA = [
  {sta_code: "00",  label: "허가"},
  {sta_code: "01",  label: "휴지"},
  {sta_code: "02",  label: "정지"},
];

function WidgetFrq2({ options, iconCodeByCls }) {
//function WidgetFrq2() {

  return (
     <Form.Item>
     <CheckboxGroupWithCheckAll
        title="무선국 구분"
        fieldName={"div_code_stats_list"}
        options={OPTIONS_DIV.map(({ div_code, label }) => ({
          value: div_code,
          label,
        }))}
        colSpan={6} />

      <Seperator />

     <CheckboxGroupWithCheckAll
        title="무선국 상태"
        fieldName={"sta_code_stats_list"}
        options={OPTIONS_STA.map(({ sta_code, label }) => ({
          value: sta_code,
          label,
        }))}
        colSpan={6} />

     <Seperator />

     <CheckboxGroupWithJointCheckAll
        title="국종"
        fieldName={"cls_code_stats_list"}
        // Todo.option
        // options={options.map(({ cls_code, label }) => ({
        options={OPTIONS_CLS.map(({ cls_code, label }) => ({
          value: cls_code,
          label,
          iconCode: iconCodeByCls[cls_code],
        }))}
        colSpan={12} />

     </Form.Item>
  );
}

export default WidgetFrq2;
